import { render, staticRenderFns } from "./ReferralsBlock.vue?vue&type=template&id=4320f2a8&"
import script from "./ReferralsBlock.vue?vue&type=script&lang=ts&"
export * from "./ReferralsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralsBlock.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports